import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Globe, Plane, Ship, Heart } from 'lucide-react';

const LOGO_URL = "https://static.prod-images.emergentagent.com/jobs/aa1f5b83-186d-4ac3-9dce-2dfcd3ce4c84/images/c740998ea2d13be287d1e30ff6aab30e0baab2ea64c21abe150888905a05c219.jpeg";

const TravelFooter = () => {
  return (
    <footer className="bg-navy-900 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-6">
              <img 
                src={LOGO_URL} 
                alt="Live Life Global Wellness Advisory Group" 
                className="h-14 w-auto"
              />
            </Link>
            <h3 className="font-serif text-xl mb-4">Live Life Global Wellness Advisory Group</h3>
            <p className="text-white/70 text-sm leading-relaxed">
              Luxury travel planning, expert consultation, and unforgettable experiences. 
              Every traveler deserves exceptional service.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-6 text-gold">Quick Links</h4>
            <ul className="space-y-3">
              {[
                { name: 'Home', path: '/' },
                { name: 'Services', path: '/services' },
                { name: 'Book Consultation', path: '/consultation' },
                { name: 'Travel Resources', path: '/resources' },
                { name: 'About Brandi', path: '/about' },
                { name: 'Contact', path: '/contact' },
              ].map((link) => (
                <li key={link.path}>
                  <Link 
                    to={link.path}
                    className="text-white/70 hover:text-gold transition-colors text-sm"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold text-lg mb-6 text-gold">Our Services</h4>
            <ul className="space-y-3">
              {[
                'Luxury Resorts',
                'Ocean Cruises',
                'River Cruises',
                'Group Travel',
                'Honeymoons',
                'Destination Weddings',
                'Family Vacations',
                'Corporate Travel',
              ].map((service) => (
                <li key={service}>
                  <span className="text-white/70 text-sm">{service}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-lg mb-6 text-gold">Contact</h4>
            <div className="space-y-4">
              <a 
                href="mailto:brandi@livelifeglobalwellness.com"
                className="flex items-center gap-3 text-white/70 hover:text-gold transition-colors"
              >
                <Mail className="w-5 h-5 text-gold" />
                <span className="text-sm">brandi@livelifeglobalwellness.com</span>
              </a>
              <div className="flex items-center gap-3 text-white/70">
                <MapPin className="w-5 h-5 text-gold" />
                <span className="text-sm">Houston, TX</span>
              </div>
              <div className="flex items-center gap-3 text-white/70">
                <Globe className="w-5 h-5 text-gold" />
                <span className="text-sm">26+ Countries Visited</span>
              </div>
            </div>

            {/* Consultation CTA */}
            <div className="mt-8 p-4 bg-gold/10 rounded-xl">
              <p className="text-gold font-semibold mb-2">Travel Consultation</p>
              <p className="text-2xl font-serif font-bold text-white">$25</p>
              <p className="text-white/60 text-xs mt-1">Credited toward your booking</p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/60 text-sm text-center md:text-left">
              © {new Date().getFullYear()} Live Life Global Wellness Advisory Group. All rights reserved.
            </p>
            <div className="flex items-center gap-6 text-white/60 text-sm">
              <Link to="/privacy" className="hover:text-gold transition-colors">Privacy Policy</Link>
              <Link to="/terms" className="hover:text-gold transition-colors">Terms of Service</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default TravelFooter;
